/**
 * Buggino – Produkt-Finder (läuft ohne Backend im Berater-Dialog).
 * Drei Fragen (Alter → Bedarf → Budget). Die Treffer sind die Schnittmenge aus
 * Alters-Kollektion und Bedarfs-Kollektion (Storefront /collections/<handle>/products.json),
 * gefiltert nach Budget; „Unsere Empfehlungen“ (Tag hero) zuerst, dann nach Preis.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-finder]');
  if (!root) return;

  const steps = Array.from(root.querySelectorAll('[data-finder-step]'));
  const dots = Array.from(root.querySelectorAll('[data-finder-dot]'));
  const result = root.querySelector('[data-finder-result]');
  const back = root.querySelector('[data-finder-back]');
  const restart = root.querySelector('[data-finder-restart]');
  const base = (root.dataset.root || '/').replace(/\/?$/, '/');
  const moneyFormat = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
  const answers = {};
  const cache = {};
  let current = 0;

  const t = (name) => {
    const el = root.querySelector(`[data-i18n-${name}]`);
    return el ? el.textContent : '';
  };

  function formatMoney(value) {
    const amount = Number(value);
    const comma = amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const dot = amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount\s*\}\}/, dot)
      .replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/, String(Math.round(amount)));
  }

  function show(index, focus = true) {
    current = index;
    steps.forEach((step, i) => {
      step.hidden = i !== index;
    });
    dots.forEach((dot, i) => dot.classList.toggle('is-done', i <= index));
    result.hidden = true;
    back.hidden = index === 0;
    restart.hidden = true;
    const first = steps[index] && steps[index].querySelector('button');
    if (focus && first) first.focus({ preventScroll: true });
  }

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(`${base}collections/${handle}/products.json?limit=250`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => d.products || [])
        .catch(() => []);
    }
    return cache[handle];
  }

  function minPrice(product) {
    const prices = (product.variants || []).filter((v) => v.available !== false).map((v) => Number(v.price));
    const all = prices.length ? prices : (product.variants || []).map((v) => Number(v.price));
    return all.length ? Math.min.apply(null, all) : 0;
  }

  function rank(list) {
    // Empfehlungen (Tag hero) zuerst, dann die Hauptprodukte (höherer Preis vor Zubehör);
    // je Produktart zunächst nur ein Treffer, damit drei verschiedene Vorschläge entstehen.
    const sorted = list.slice().sort((a, b) => {
      const ha = (a.tags || []).includes('hero') ? 0 : 1;
      const hb = (b.tags || []).includes('hero') ? 0 : 1;
      return ha - hb || minPrice(b) - minPrice(a);
    });
    const seen = new Set();
    const first = [];
    const rest = [];
    sorted.forEach((p) => {
      const type = (p.product_type || '').toLowerCase();
      if (!seen.has(type)) {
        seen.add(type);
        first.push(p);
      } else rest.push(p);
    });
    return first.concat(rest);
  }

  function card(product) {
    const img = product.images && product.images[0] ? product.images[0].src : '';
    const src = img ? `${img}${img.includes('?') ? '&' : '?'}width=240` : '';
    const a = document.createElement('a');
    a.className = 'finder__card';
    a.href = `${base}products/${product.handle}`;
    a.innerHTML = `${src ? `<img src="${src}" alt="" width="120" height="120" loading="lazy">` : ''}<span class="finder__card-body"><span class="finder__card-title"></span><span class="finder__card-price"></span></span>`;
    a.querySelector('.finder__card-title').textContent = product.title;
    a.querySelector('.finder__card-price').textContent = formatMoney(minPrice(product));
    return a;
  }

  async function finish() {
    steps.forEach((s) => (s.hidden = true));
    dots.forEach((d) => d.classList.add('is-done'));
    back.hidden = false;
    restart.hidden = false;
    result.hidden = false;
    result.innerHTML = `<p class="finder__note">${t('loading')}</p>`;
    try {
      const [ageList, needList] = await Promise.all([load(answers.age), load(answers.need)]);
      const ageIds = new Set(ageList.map((p) => p.id));
      let pool = needList.filter((p) => ageIds.has(p.id));
      const notes = [];
      if (!pool.length) {
        pool = needList;
        notes.push(t('fallback'));
      }
      const [lo, hi] = answers.budget.split('-').map(Number);
      let picks = pool.filter((p) => {
        const price = minPrice(p);
        return price >= lo && price <= hi;
      });
      let relaxed = false;
      if (!picks.length && pool.length) {
        // Nichts im Budget: die günstigsten Alternativen, aufsteigend nach Preis (nicht neu sortieren)
        picks = pool.slice().sort((a, b) => minPrice(a) - minPrice(b)).slice(0, 3);
        relaxed = true;
        notes.push(t('budget-relaxed'));
      }
      picks = relaxed ? picks : rank(picks).slice(0, 3);
      result.innerHTML = '';
      const intro = document.createElement('p');
      intro.className = 'finder__q';
      intro.textContent = t('intro');
      result.appendChild(intro);
      notes.forEach((n) => {
        const p = document.createElement('p');
        p.className = 'finder__note';
        p.textContent = n;
        result.appendChild(p);
      });
      const list = document.createElement('div');
      list.className = 'finder__cards';
      picks.forEach((p) => list.appendChild(card(p)));
      result.appendChild(list);
      const all = document.createElement('a');
      all.className = 'btn btn--primary btn--sm finder__all';
      all.href = `${base}collections/${answers.need}`;
      all.textContent = t('all');
      result.appendChild(all);
    } catch (e) {
      result.innerHTML = `<p class="finder__note">${t('error')}</p>`;
    }
  }

  steps.forEach((step, index) => {
    step.querySelectorAll('.finder__opt').forEach((button) => {
      button.addEventListener('click', () => {
        answers[step.dataset.finderStep] = button.dataset.value;
        step.querySelectorAll('.finder__opt').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        if (index < steps.length - 1) show(index + 1);
        else finish();
      });
    });
  });

  back.addEventListener('click', () => show(Math.max(0, result.hidden ? current - 1 : steps.length - 1)));
  restart.addEventListener('click', () => {
    Object.keys(answers).forEach((k) => delete answers[k]);
    root.querySelectorAll('.finder__opt').forEach((b) => b.removeAttribute('aria-pressed'));
    show(0);
  });

  show(0, false);
})();
